<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("profile.mfaTitle") }}</h5>
    <vue-element-loading :active="isLoading" spinner="spinner" />
    <div class="card">
      <div class="card-content">
        <h6 class="title is-6">現在多要素認証を設定済みです</h6>
        <p>
          多要素認証を解除します。<br />
          現在利用している確認コードは利用できなくなります。<br />
          （再利用には再設定が必要となります）<br />
          PESCLEの利用には多要素認証の利用を強くおすすめします。<br />
          問題がなければこのまま、多要素認証の継続利用をお願い致します。
        </p>
        <div>
          <button
            class="button is-danger mt-3"
            v-bind:class="{ 'is-loading': isLoad }"
            @click="unsetMfa"
          >
            {{ $t("auth.removeMfa") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import VueElementLoading from "vue-element-loading";
import { ref } from "@vue/reactivity";
import { ImsrUsers } from "@/lib/imsrUsers.js";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
export default {
  components: {
    Breadcrumb,
    VueElementLoading,
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const isLoading = ref(false);
    const isLoad = ref(false);
    const breadcrumb = ref([
      { title: "Home", path: "/" },
      { title: "Profile", path: { name: "profileView" } },
      { title: "MFA", path: "#", isActive: true },
    ]);

    const unsetMfa = async () => {
      try {
        isLoad.value = true;
        const imsrUsers = new ImsrUsers();
        await imsrUsers.unsetMfa(store.getters.tenantId);
        isLoad.value = false;
        store.commit("setMessage", t("profile.unsetMfa"));
        router.push({ name: "profileView" });
      } catch (e) {
        console.log("cant unset mfa"); // eslint-disable-line no-console
      }
    };

    return {
      breadcrumb,
      isLoading,
      isLoad,
      unsetMfa,
    };
  },
};
</script>
